// extracted by css-extract-rspack-plugin
var _1 = "ulkk47GucrYobxms";
var _2 = "ulkk47GucrYobxms";
export { _1 as "draw-container", _2 as "drawContainer" }
